import { defineStore } from "pinia";
import SettingResource from "~/models/substitute/Setting";
import StaffResource from "~/models/substitute/Staff";

export const useSubstituteStore = defineStore("substitute", {
  state: () => ({
    current_building: null,
    master_schedule_link: null,
    lesson_plans_folder_link: null,
    buildings: [
      { value: 100, label: "East Leyden High School" },
      { value: 200, label: "West Leyden High School" },
      { value: 300, label: "LIFE Transition Program" },
    ],
    loading_staff: false,
    staff: [],
    loading_my_staff: false,
    my_staff: [],
  }),
  getters: {},
  actions: {
    async loadConfig() {
      const auth = useAuthStore();

      try {
        this.loading_my_staff = true;
        this.my_staff = [];

        // Load system settings
        const settings = await SettingResource.$all();
        settings.forEach((setting) => {
          this[setting.name] = setting.value;
        });

        // Get currently assigned staff
        this.setMyStaff(
          await StaffResource.where("SUB_LOGIN_ID", auth.user.username)
            .orderBy(["LAST_NAME", "FIRST_NAME"])
            .$get()
        );

        this.loading_my_staff = false;
      } catch (error) {
        this.loading_my_staff = false;
        useApiResponseHandler().error(error, "Failed to load my attendance staff: ");
      }
    },
    async loadStaff() {
      if (!this.current_building) {
        this.staff = [];
        return;
      }

      try {
        this.loading_staff = true;
        this.staff = [];

        this.staff = await StaffResource.whereIn("in_buildings", [
          this.current_building,
        ])
          .where("has_email", 1)
          .orderBy(["LAST_NAME", "FIRST_NAME"])
          .$get();
        this.loading_staff = false;
      } catch (error) {
        this.loading_staff = false;
        useApiResponseHandler().error(error, "Failed to load staff: ");
      }
    },
    setMyStaff(staffList) {
      this.my_staff = staffList;
    },
  },
});
